import {RouteConfig} from 'vue-router';
import {loginRoutes} from './login';
import {homepageRoutes} from './homepage';
import {aboutRoutes} from './about';

export const publicRoutes : RouteConfig = {
  path: 'public',
  component: () => import('@/views/public/PublicView.vue'),
  children: [
    homepageRoutes,
    loginRoutes,
    aboutRoutes,
  ],
};
